import {typedConnect} from '../../../../commons/components/runtime-context/connect'
import {AppProps} from '../app/interfaces'

export const connect = typedConnect<AppProps>()
